import React from 'react';
import Icon from '../../../components/AppIcon';

const MatchCelebration = ({ match, onViewMatches, onKeepExploring }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center animate-scale-in">
        <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="Heart" size={40} color="#FFFFFF" />
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-3">It's a Match!</h2>
        <p className="text-gray-600 mb-8">
          The employer is also interested in your profile. You can now start a conversation.
        </p>
        <div className="space-y-3">
          <button
            onClick={onViewMatches}
            className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium rounded-lg transition-colors"
          >
            View Matches
          </button>
          <button
            onClick={onKeepExploring}
            className="w-full px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors"
          >
            Keep Exploring
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchCelebration;